import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import { isContentstackEnabled } from 'yoda-site-components/lib/cms-renderer/utils';
import Iris from './Iris';
import Contentstack from './Contentstack';

/**
 * Marketing — Entry point / Switcher.
 * Checks feature flag and routes to Iris or Contentstack.
 * Both are parallel. No interconnection.
 */
function Marketing(props) {
    const { enableContentstackCMS, contentstackPageList, location } = props;

    if (isContentstackEnabled(enableContentstackCMS, location, contentstackPageList)) {
        return <Contentstack {...props} />;
    }

    return <Iris {...props} />;
}

const mapStateToProps = ({ context }) => {
    const featureFlags = get(context, 'featureFlags', {});
    const preferences = get(context, 'preferences', {});

    return {
        enableContentstackCMS: featureFlags.enableContentstackCMS || false,
        contentstackPageList: get(preferences, 'contentstackPageList', []),
    };
};

export default withRouter(connect(mapStateToProps)(Marketing));
